// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2Pe5E","inputWrap":"CustomTip_inputWrap__1tgdu"};